const formatStringAsPercent = (input) => `${Number.parseFloat(input)}%`;
const formatStringAsMg = (input) => `${Number.parseFloat(input)}mg`;

const getPercentOrMg = (percent, mg) => {
  if (!percent && !mg) {
    return '';
  }

  return percent ? formatStringAsPercent(percent) : formatStringAsMg(mg);
};

export default getPercentOrMg;
